<template>
  <main class="verify-error">
    <div class="ve-card">
      <!-- 圖示 -->
      <div class="ve-icon">
        <svg viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="26" cy="26" r="25" stroke="#c0392b" stroke-width="2"/>
          <path d="M18 18L34 34M34 18L18 34" stroke="#c0392b" stroke-width="2.5"
                stroke-linecap="round"/>
        </svg>
      </div>

      <h1 class="ve-title">{{ title }}</h1>
      <p class="ve-msg">{{ message }}</p>

      <div class="ve-actions">
        <router-link :to="{ name: 'BookingHome' }" class="ve-btn ve-btn--primary">
          重新預約
        </router-link>
        <router-link :to="{ name: 'BookingQuery' }" class="ve-btn ve-btn--secondary">
          查詢已有預約
        </router-link>
      </div>
    </div>
  </main>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const title = computed(() => {
  switch (route.query.reason) {
    case 'expired': return '驗證連結已過期'
    case 'invalid': return '驗證連結無效'
    default:        return '驗證失敗'
  }
})

const message = computed(() => {
  switch (route.query.reason) {
    case 'expired':
      return '此驗證連結已超過 30 分鐘有效期，預約已自動取消。請重新填寫預約資料。'
    case 'invalid':
      return '驗證連結無效或已使用過，若您已完成驗證，可直接查詢您的預約。'
    default:
      return '驗證過程發生錯誤，請稍後再試，或直接聯絡店家確認。'
  }
})
</script>

<style scoped>
.verify-error {
  max-width: 480px;
  margin: 0 auto;
  padding: 60px 16px 80px;
  text-align: center;
}
.ve-card {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.ve-icon {
  width: 64px;
  height: 64px;
  margin-bottom: 24px;
}
.ve-icon svg { width: 100%; height: 100%; }
.ve-title {
  font-size: 1.5rem;
  color: #c0392b;
  margin: 0 0 16px;
}
.ve-msg {
  font-size: 0.95rem;
  color: #666;
  line-height: 1.7;
  margin: 0 0 36px;
}
.ve-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}
.ve-btn {
  display: block;
  width: 100%;
  padding: 13px 24px;
  border-radius: 8px;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  box-sizing: border-box;
  transition: background 0.15s;
}
.ve-btn--primary  { background: #8b6f5c; color: #fff; }
.ve-btn--primary:hover { background: #7a5f4d; }
.ve-btn--secondary {
  background: transparent;
  border: 1px solid #8b6f5c;
  color: #8b6f5c;
}
.ve-btn--secondary:hover { background: #f5ede8; }

@media (min-width: 400px) {
  .ve-actions { flex-direction: row; justify-content: center; }
  .ve-btn { width: auto; min-width: 150px; }
}
</style>
